export default {
    'contact.companyInfo.contactUs':'联系我们',
    'contact.companyInfo.h2.01':'深圳总部办公室',
    'contact.companyInfo.p.01':'广东省深圳市龙华区大浪工业园',
    'contact.companyInfo.h2.02':'联系电话',
    'contact.companyInfo.p.02':'电话：+86 18688782252，whatsApp,skype +86 18576744474',

    'contact.companyInfo.cardServer.h1':'工作时间',
    'contact.companyInfo.cardServer.p':'为您提供至上服务是我们的使命。',
    'contact.companyInfo.cardServer.div1.span1':'周一至周六',
    'contact.companyInfo.cardServer.div1.span2':'8:00 ~ 22:00',
    'contact.companyInfo.cardServer.div2.span1':'人工客服',
    'contact.companyInfo.cardServer.div2.span2':'7 * 24小时',
    'contact.companyInfo.cardServer.div3.span1':'物流服务',
    'contact.companyInfo.cardServer.div3.span2':'7 * 24小时',


    'contact.form.h1':'留言咨询',
    'contact.form.label.name':'姓名',
    'contact.form.label.name.placeholder':'请输入姓名',
    'contact.form.label.type':'咨询类型',
    'contact.form.label.type.placeholder':'请输入咨询类型',
    'contact.form.label.type.option.01':'产品询价',
    'contact.form.label.type.option.02':'物流报价',
    'contact.form.label.type.option.03':'物流查询',
    'contact.form.label.type.option.04':'客户服务',
    'contact.form.label.type.option.other':'其他',
    'contact.form.label.email':'邮箱',
    'contact.form.label.email.placeholder':'请输入您的邮箱',
    'contact.form.label.phone':'联系方式',
    'contact.form.label.phone.placeholder':'请输入电话号码/WhatsAPP/Skype',
    'contact.form.label.content':'留言',
    'contact.form.label.content.placeholder':'请输入你的留言',
    'content.form.submit':'提交'
}